import readCookie from './readCookie';
import hasNumber from './hasNumber';
var autoComplete = (function () {

    var setUpAutoComplete = function () {

        $.extend($.ui.autocomplete.prototype, {
            // create selection function
            _createSelection: function($input, start, end) {
    
                // get a reference to the input element
                var field = $input.get(0);

                // set the selection (browser specific methods)
                if( field.createTextRange ){
                    var selRange = field.createTextRange();
                    selRange.collapse(true);
                    selRange.moveStart("character", start);
                    selRange.moveEnd("character", end);
                    selRange.select();
                } else if( field.setSelectionRange ){
                    field.setSelectionRange(start, end);
                } else {
                    if( field.selectionStart ){
                        field.selectionStart = start;
                        field.selectionEnd = end;
                    }
                }
                field.focus();
            },
            // auto fill function
            _autoFill: function($input, sValue) {
                var inputQuery = $input.val().toLowerCase();
                var matchedItem = sValue.toLowerCase();
                // here 'this' is the plugin itself
                // do nothing on backspace and command keys and when unmatched texted is entered
                if ((this.lastKeyPressCode != 46 && (this.lastKeyPressCode < 8 || this.lastKeyPressCode > 32)) &&
                    ( matchedItem.indexOf( inputQuery ) > -1)) {
                    // fill in the value (keep the case the user has typed)
                    $input.val($input.val() + sValue.substring(this._previousValue.length));
    
                    // select the portion of the value not typed by the user (so the next character will erase)
                    this._createSelection($input, this._previousValue.length, sValue.length);
                }
            },
    
            _previousValue: '',
            lastKeyPressCode: null
        });
    
        // .on( "autocompleteopen", function() {
        //     var $this = $(this),
        //         autocomplete = $this.data( "uiAutocomplete" ),
        //         menu = autocomplete.menu;
        //     var autoFillValue = '';
        //     // check the 'selectFirst' setting
        //     if ( !autocomplete.options.selectFirst ) {
        //         return;
        //     }
        //     // activate the menu
        //     // menu.activate( $.Event({ type: "mouseenter" }), menu.element.children().first() );
        //     if(readCookie('locationName') == 'nearby'){
        //         // if there is 'near me' on the list, auto fill value is the second item in the list
        //         autoFillValue = menu.element.children().eq(1).text();
        //     }else{
        //         // if there isn't 'near me' on the list, auto fill value is the first item in the list 
        //         autoFillValue = menu.element.children().first().text();
        //     }
        //     // set the autoFill
        //     autocomplete._autoFill($this, autoFillValue);
        // });
        
        // Google autocomplete service
        var service = new google.maps.places.AutocompleteService();
        // initial location list
        var locationList = [];

        var injectAutoComplete = function (){
            
            $( "#location-search" )
            .keyup( function(event) {
                var $this = $(this),
                    autocomplete = $this.data('uiAutocomplete'),
                    key;
                autocomplete.lastKeyPressCode = key = event.which;
                // do nothing on backspace and command keys
                if( key == 46 || (key > 8 && key < 32) ){
                    // return menu.deactivate();
                    return;
                    // return $this.autocomplete('close');
                }
    
                // check value is different
                var currentValue = $this.val();
                if (currentValue == autocomplete._previousValue)
                    return;
    
                // save value
                autocomplete._previousValue = currentValue;
            })

            // selectFirst: true,
            $("#location-search").autocomplete({
                selectFirst: true,
                source: function (request, response) {
                    var predictionReceived = $.Deferred();
                    if(request.term) {
                        $.when(inputLocationName(request.term, predictionReceived))
                        .then( function (locationList) {
                            response(locationList);
                        });
                    }else{
                        // resetResults();
                        $("#location-search").autocomplete('close');
                    }
                },
                minLength: 3,
                response: function( event, ui){
                    // Add near me when geo location is provided
                    if(readCookie('latitude')){
                        ui.content.unshift({value:"Near me", label:"Near me"});
                    }
                },
                open: function(event, ui) {
                    // for click twice on mobile for auto complete list
                    $('.ui-autocomplete').off('menufocus hover mouseover mouseenter');
                    
                    var $this = $(this),
                        autocomplete = $this.data( "uiAutocomplete" ),
                        menu = autocomplete.menu;
                    var autoFillValue = '';
                    // check the 'selectFirst' setting
                    // disable postcode auto prefill
                    if ( !autocomplete.options.selectFirst || hasNumber($this.val())) {
                        return;
                    }
                    // activate the menu
                    // menu.activate( $.Event({ type: "mouseenter" }), menu.element.children().first() );
                    if(readCookie('locationName') == 'nearby'){
                        // if there is 'near me' on the list, auto fill value is the second item in the list
                        autoFillValue = menu.element.children().eq(1).text();
                    }else{
                        // if there isn't 'near me' on the list, auto fill value is the first item in the list 
                        autoFillValue = menu.element.children().first().text();
                    }
                    // set the autoFill
                    autocomplete._autoFill($this, autoFillValue);
                }
            });
        }

        injectAutoComplete();


        // set up expire time for cookie
        var now = new Date();
        var time = now.getTime();
        var expireTime = time + 1000*3600000;
        now.setTime(expireTime);
        var expires = '; expires=' + now.toUTCString();

        var returnResults = '';
        var returnPointState = [];
        // search widget form submit function
        $('#search-widget-form').submit('click', function(e){
            var saveAddress = $("#location-search").val();
            sessionStorage.setItem('location', saveAddress);
            e.preventDefault();
            var suburb = $("#location-search").val();
            if(suburb == ''){
                // window.location.href = "/return-points";
                // window.location.href = "/return-point-results.html";
                // window.location.href = "/return-points";
                $('.c-form--search-widget__text').addClass('c-form--search-widget__text-error');
            }else if(suburb == 'Near me'){
                // if near me is chosen, use geo location data which is stored in cookie
                document.cookie = "locationName=" + 'nearby' + expires + '; path=/';
                window.location.href = "/return-points";
            }
            else if(returnResults == 'ZERO_RESULTS'){
                $('.c-form--search-widget__text').addClass('c-form--search-widget__text-error');
                // for dummy input
                window.location.href = "/return-points?" 
                + 'outOfState' 
                + '&locationName=' + locationList[0];
            }
            else if(returnPointState.indexOf('NSW') == -1){
                // for valid input, such as brisbane, but no results
                window.location.href = "/return-points?" 
                + 'outOfState' 
                + '&locationName=' + suburb;
                $('.c-form--search-widget__text').addClass('c-form--search-widget__text-error');
            }
            else{
                $('.c-form--search-widget__text').removeClass('c-form--search-widget__text-error');
                var geocoder = new google.maps.Geocoder();
                if (geocoder) {
                    geocoder.geocode({
                        'address': suburb
                    }, function (results, status) {
                        // if input 'location' has matched location result
                        if (status != 'ZERO_RESULTS' &&
                            status == google.maps.GeocoderStatus.OK){
                            // if user choose location name from result list
                            if( locationList.indexOf(suburb) > -1){                                
                                createQueryString(results);
                            }else{
                                /** if user type 'letters' which has matched result, but locaiton isnt 
                                    selected from result list
                                    and typed 'letters' doesnt make sence to google to find right geo data
                                    For example, 'sy' will trigger match 'sydney' and 'sydney olympic park'
                                    but doesnt make sence for google to find the right geo data
                                    for this case, will use the first item of result list to get geo data
                                */
                                if(geocoder){
                                    geocoder.geocode({
                                        'address': locationList[0]
                                    }, function (results, status) {
                                        if (status != 'ZERO_RESULTS' &&
                                            status == google.maps.GeocoderStatus.OK){
                                                createQueryString(results);
                                        }
                                    });
                                }
                            }
                        }
                        // if input 'location' does not has matched location result
                        else{
                            // Log errors
                            console.log('Geocode status : '+ status);
                            console.log('Geocode query error : '+ google.maps.GeocoderStatus.OK);

                            // Redirect
                            window.location.href = "/return-points?" 
                            + 'outOfState' 
                            + '&locationName=' + suburb;
                        }
                    });
                }
            }

        });
        var createQueryString = function(results){
            var selectedLocationName = '';
            if(hasNumbers(results[0].address_components[0].long_name)){
                selectedLocationName =results[0].address_components[1].long_name;
            }else{
                selectedLocationName =results[0].address_components[0].long_name;
            }
            window.location.href = "/return-points?" 
                + 'latitude=' + results[0].geometry.location.lat()
                + "&longitude=" + results[0].geometry.location.lng()
                + "&locationName=" + selectedLocationName;
        }
        var hasNumbers = function(s){
            return /\d/.test(s);
        }
        var resetResults = function(){
            locationList = [];
        }
        // session token for auto complete search
        var sessionToken = new google.maps.places.AutocompleteSessionToken();
        
        var inputLocationName = function(search, predictionReceived){
            var sydenyGeoData = new google.maps.LatLng(-33.868820, 151.209296);

            var getLocations = function (data){
              
              
                resetResults();
                returnPointState = [];
                /**
                 * https://github.com/sgruhier/typeahead-addresspicker/issues/20
                 * Only return 5 results
                 */ 
                locationList = [];
                var predictions = data.predictions;
                predictions.forEach(function(prediction, index) {
                    
                    if(prediction.terms.length >= 2){
                        returnPointState.push(prediction.terms[1].value);
                        // only results for nsw will be added on list
                        if(prediction.terms[1].value == 'NSW'){
                            // push each result main text into array
                            locationList.push(prediction.description);
                        }
                    }
                    if( index === predictions.length -1 ){
                        predictionReceived.resolve(locationList);
                    } 
    
                });
            }

            var locationOrigin = window.location.origin;
            $.ajax({
                method: 'GET',
                url: locationOrigin + "/api/googleplaces/getPlacesPrediction/",
                data:{
                    "term": search,
                    "latitude": "-33.868820",
                    "longitude": "151.209296",
                    "session":sessionToken
                },
                success: function(response){
              
                if(response.status == "ok" && response.data.status != "ZERO_RESULTS"){
                    var predictionsData = response.data;
                    getLocations(predictionsData);                     
                } 
                },
                error: function(response){
                }
            });           

            return predictionReceived.promise();
        }
    };
  
    var init = function () {
      setUpAutoComplete();
    };
  
    return {
      init: init
    };
})();
  
export default autoComplete;


// WEBPACK FOOTER //
// ./FE-Build/src/js/modules/autoComplete.js